/**
 * Pre-compiled en messages for Avatar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  avatarLabel: (args: Record<string, string | number>) =>
    `Avatar image for ${args.fullName}`,
  avatarLabelGeneric: `Generic user avatar`,
};
